module.exports = __webpack_public_path__ + "static/img/partner3.f7e8cbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner3.png
// module id = fYyE
// module chunks = 0